export { default as SocialFooterBar } from './FooterBar.component'
